export const NAME_MODELNUMBER = "ModelNumber"
export const NAME_MANUFACTURER = "ManufacturerName"
export const NAME_PRODUCTTYPE = "HeatingModelTypeName"
export const NAME_NOTES = "Notes"

